import { render } from "./UsefulLinks.vue?vue&type=template&id=610625d7&scoped=true&ts=true"
import script from "./UsefulLinks.vue?vue&type=script&lang=ts"
export * from "./UsefulLinks.vue?vue&type=script&lang=ts"

import "./UsefulLinks.vue?vue&type=style&index=0&id=610625d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610625d7"]])

export default __exports__